/**
 * Created by Ning Jiang on 2021-06-21.
 */

import {TimelineLite, TweenLite} from "gsap";
import {WaysWonTextContainer} from "./WaysWonTextContainer";
import {ElGordosRevengeLayers, Layers} from "../../../view/ElGordosRevengeLayers";

export class WaysWonCountUp extends PIXI.Container {

    private readonly _initialPositionY:number = 480;
    // private readonly _bigWinPositionY:number = 630;

    private _waysWonContainer:WaysWonTextContainer;
    private _removeTl:TimelineLite | null;

    public set externalAlpha(value:number) {
        this._waysWonContainer.alpha = value;
    }

    public get externalAlpha():number {
        return this._waysWonContainer.alpha;
    }

    constructor() {
        super();

        this._waysWonContainer = new WaysWonTextContainer();
        this._waysWonContainer.visible = false;
        this.addChild(this._waysWonContainer);
        ElGordosRevengeLayers.getLayer(Layers.WIN_WAYS)?.addChild(this);
        // this.showWinWaysWon(5, false);
    }

    public showWinWaysWon(winWaysWon:number, isBigWin:boolean):TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._waysWonContainer.alpha = 0;
                this._waysWonContainer.visible = true;
                this.position.set(360, this._initialPositionY);
                this._waysWonContainer.show(winWaysWon);
            },
            TweenLite.to(this._waysWonContainer, 0.5, {alpha : 1}),
        ]);

        return tl;
    }

    public stay():void {
        const tl = new TimelineLite();
        tl.add(TweenLite.to(this, 0.01, {y : this._initialPositionY}));
    }

    public remove():TimelineLite {
        this.resetRemoveTl();
        const tl = new TimelineLite();
        tl.add(TweenLite.to(this._waysWonContainer, 0.5, {alpha : 0}), `+=0.2`);
        tl.add(() => {this._waysWonContainer.visible = false});
        this._removeTl = tl;
        return tl;
    }

    public showAfterRemoved():void {
        this.resetRemoveTl();
        this.y = this._initialPositionY;
        this._waysWonContainer.visible = true;
        this._waysWonContainer.alpha = 1;
    }

    private resetRemoveTl():void {
        if(this._removeTl && this._removeTl.isActive()) {
            this._removeTl.paused();
            this._removeTl.kill();
        }
        this._removeTl = null;
    }

    public setColor(color:number):void {
        this._waysWonContainer.setColor(color);
    }
}